import React from 'react'
import { localized } from 'decorators/localized'
import { LinkButton } from 'components/buttons'
import { useStyles } from './footer.css'
import logo from 'assets/images/logo.png'
import { ApplicationVersion } from './applicationVersion'

const Footer = (props) => {
  const classes = useStyles()
  return (
    <footer className={classes.root}>
      <img className={classes.img} alt='logo' src={logo} />
      <LinkButton href='/release-notes' title={props.localize('common.releaseNotes')}><span className={classes.span}><ApplicationVersion /></span></LinkButton>
      <div className={classes.copyright}>{`©${new Date().getFullYear()} ${props.localize('common.copyright')}`}</div>
    </footer>
  )
}

export default localized(Footer)
